import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { useEffect } from "react";
import { awaitDomElement, awaitTimeout } from "@/utils/GlobalJavascriptFunction";
import { checkTestFlag } from "@/common/config/websiteConfig";
import { useTranslation } from "@i18n";
var MOYASAR_SCRIPT = "https://cdn.jsdelivr.net/npm/moyasar-payment-form@2.2.7/dist/moyasar.umd.min.js";
var MOYASAR_STYLES = "https://cdn.jsdelivr.net/npm/moyasar-payment-form@2.2.7/dist/moyasar.css";
function useMoyasarHook(_ref) {
  var divSelector = _ref.divSelector,
    paymentSession = _ref.paymentSession,
    events = _ref.events,
    template = _ref.template,
    internvalTimeoutSeconds = _ref.internvalTimeoutSeconds;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  function init() {
    var script = document.createElement("script");
    var style = document.createElement("link");
    style.href = MOYASAR_STYLES;
    style.rel = "stylesheet";
    script.src = MOYASAR_SCRIPT;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
    document.head.appendChild(style);
    var element = document.querySelector(divSelector);
    script.onload = /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var createAsyncCallback, asyncCallbacks, injectedButton;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!checkTestFlag("TEST_DELAY_API_TIME__3000")) {
              _context.n = 1;
              break;
            }
            _context.n = 1;
            return awaitTimeout(3000);
          case 1:
            if (!checkTestFlag("TEST_DELAY_API_TIME__60000")) {
              _context.n = 2;
              break;
            }
            _context.n = 2;
            return awaitTimeout(60000);
          case 2:
            if (!checkTestFlag("TEST_API_500")) {
              _context.n = 3;
              break;
            }
            console.log("Simulated 500 Internal Server Error (Moyasar)");
            throw new Error("Simulated 500 Internal Server Error (Moyasar)");
          case 3:
            // Create non-transpiled async functions using eval
            createAsyncCallback = function createAsyncCallback(callbackType) {
              var funcStrMap = {
                on_initiating: "\n                    (async function() {\n                        const result = await eventsRef.on_initiating();\n                        return result;\n                    })\n                ",
                on_completed: "\n                    (async function() {\n                        await eventsRef.on_completed();\n                    })\n                ",
                on_failure: "\n                    (async function(error) {\n                        console.log(error);\n                        window.location.reload();\n                    })\n                "
              };
              return eval(funcStrMap[callbackType]);
            }; // Make events available in the scope
            window.eventsRef = events;
            asyncCallbacks = {
              on_initiating: createAsyncCallback('on_initiating'),
              // on_completed: createAsyncCallback('on_completed'),
              on_failure: createAsyncCallback('on_failure')
            };
            console.log('Callbacks created:', Object.keys(asyncCallbacks));
            Moyasar.init(_objectSpread({
              element: element,
              amount: paymentSession.amount,
              currency: paymentSession.currency,
              description: paymentSession.description,
              metadata: paymentSession.metadata,
              publishable_api_key: process.env.RAZZLE_MOYASAR_PUBLISHABLE_API_KEY,
              callback_url: paymentSession.success_url,
              supported_networks: ["mada", "visa", "mastercard"],
              methods: ["creditcard", "applepay"
              //"stcpay"
              ],
              apple_pay: {
                country: "SA",
                label: paymentSession.description_en,
                validate_merchant_url: "https://api.moyasar.com/v1/applepay/initiate",
                supported_countries: ["SA", "JO"]
              }
            }, asyncCallbacks));
            _context.n = 4;
            return awaitDomElement('#mysr > div > form > button');
          case 4:
            injectedButton = _context.v;
            if (injectedButton) {
              injectedButton.id = "mysr-form-submit";
              injectedButton.innerHTML = "\n                        <strong class=\"show\">".concat(template.payButtonText, "</strong>\n                        <strong class=\"show\">").concat(+paymentSession.amount / 100, " <span class='currency'>\n                        ").concat(t("sar", {
                ns: "web_common"
              }), "\n                        </span>\n                        </strong>\n                    ");
            }
          case 5:
            return _context.a(2);
        }
      }, _callee);
    }));
  }
  useEffect(function () {
    var interval = setInterval(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
      var isReservedOrPaid;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            _context2.n = 1;
            return events.on_initiating();
          case 1:
            isReservedOrPaid = !_context2.v;
            if (isReservedOrPaid) {
              location.reload();
            }
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    })), internvalTimeoutSeconds * 1000);
    init();
    return function () {
      return clearInterval(interval);
    };
  }, []);
}
export default useMoyasarHook;